export default __webpack_public_path__ + "static/media/waffle7.87a6cebe.png";